import {
  HomeIcon,
  UserIcon,
  HomeModernIcon,
  UserGroupIcon,
  IdentificationIcon,
  BriefcaseIcon,
  PhoneIcon,
  AcademicCapIcon,
  ShoppingCartIcon,
  PresentationChartBarIcon,
  ServerIcon,
  PhotoIcon,
  ChatBubbleLeftRightIcon,
} from "@heroicons/react/24/outline";
import { IoIosImages } from "react-icons/io";
import { FcFaq } from "react-icons/fc";
import { TiUserAdd } from "react-icons/ti";
import { PiBrowsersDuotone } from "react-icons/pi";
import { MdConnectWithoutContact } from "react-icons/md";
import { FcGraduationCap } from "react-icons/fc";
import { IoMdAppstore } from "react-icons/io";
import { FcBriefcase } from "react-icons/fc";
import { GiAstrolabe } from "react-icons/gi";
import { AiOutlineExperiment } from "react-icons/ai";
import { FaUserGraduate } from "react-icons/fa6";
import { FcHome } from "react-icons/fc";
import { FaRegUser } from "react-icons/fa";
import { MdProductionQuantityLimits } from "react-icons/md";
import { FcContacts } from "react-icons/fc";
import { FcNews } from "react-icons/fc";
import { FcAddImage } from "react-icons/fc";
import { GiSellCard } from "react-icons/gi";
import { BsBadge3dFill } from "react-icons/bs";
import { BsFillChatTextFill } from "react-icons/bs";
import { FaCompactDisc } from "react-icons/fa";
import { FcPrivacy } from "react-icons/fc";
import { FcTimeline } from "react-icons/fc";
import { MdRecycling } from "react-icons/md";
import { CgScrollH } from "react-icons/cg";
import { LuReplaceAll } from "react-icons/lu";
import { BsBodyText } from "react-icons/bs";
import { TfiLayoutSliderAlt } from "react-icons/tfi";
import { BsCreditCard2Front } from "react-icons/bs";
import { FcBusinessContact } from "react-icons/fc";
import { SiRedash } from "react-icons/si";
import { SiDashlane } from "react-icons/si";
import { RiTeamFill } from "react-icons/ri";
import { BiSolidCertification } from "react-icons/bi";
import { GrGallery } from "react-icons/gr";
export const sidebarData = [
  {
    id: 1,
    // path: "/",
    title: "Home Section",
    icon: <FcHome className=" sidebar-icon " />,

    subTitle: [
      {
        id: 1,
        path: "home/imagecarsoul",
        title: "Image Carousel",
        icon: <FcAddImage className=" sidebar-icon " />,
      },
      {
        id: 2,
        path: "home/scroolcard",
        title: "Scrool Card",
        icon: <GiSellCard className=" sidebar-icon " />,
      },
    ],
  },
  {
    id: 1,
    // path: "/",
    title: "About Section",
    icon: <FaRegUser className=" sidebar-icon " />,
    subTitle: [
      {
        id: 1,
        path: "about/rotatecube",
        title: "3D Cube",
        icon: <BsBadge3dFill className=" sidebar-icon " />,
      },
      {
        id: 2,
        path: "about/aboutsection2",
        title: "Text Section",
        icon: <BsFillChatTextFill className=" sidebar-icon " />,
      },
      {
        id: 3,
        path: "about/aboutsection3",
        title: "Discover Section",
        icon: <FaCompactDisc className=" sidebar-icon " />,
      },
      {
        id: 4,
        path: "about/privacy",
        title: "Privacy Section",
        icon: <FcPrivacy className=" sidebar-icon " />,
      },
      {
        id: 5,
        path: "about/timeline",
        title: "Timeline Section",
        icon: <FcTimeline className=" sidebar-icon " />,
      },
      {
        id: 6,

        path: "about/aboutsection4",
        title: "Client Section",
        icon: <MdRecycling className=" sidebar-icon " />,
      },
      {
        id: 7,
        path: "about/marquetop",
        title: "Marquee",
        icon: <CgScrollH className=" sidebar-icon " />,
      },
    ],
  },

  {
    id: 1,
    // path: "/",
    title: "Products Section",
    icon: <MdProductionQuantityLimits className=" sidebar-icon " />,
    subTitle: [
      {
        id: 1,
        path: "products/allproducts",
        title: "All Products",
        icon: <LuReplaceAll className=" sidebar-icon " />,
      },
      {
        id: 1,
        path: "products/viewtext",
        title: "View Text",
        icon: <BsBodyText className=" sidebar-icon " />,
      },
    ],
  },

  {
    id: 1,
    // path: "/",
    title: "News Section",
    icon: <FcNews className=" sidebar-icon " />,
    subTitle: [
      {
        id: 1,
        path: "newscarsoul",
        title: "Carousel",
        icon: <TfiLayoutSliderAlt className=" sidebar-icon " />,
      },

      {
        id: 2,
        path: "newscard",
        title: "Card",
        icon: <BsCreditCard2Front className=" sidebar-icon " />,
      },
    ],
  },
];

export const defaultSiderBar = [
  {
    id: 1,
    path: "/admin/dashboard",
    title: "DashBoard",
    icon: <SiDashlane className=" sidebar-icon " />,
  },
  {
    id: 2,
    path: "/admin/user",
    title: "User",
    icon: <TiUserAdd className=" sidebar-icon " />,
  },
  {
    id: 9,
    path: "/admin/banner",
    title: "Banner Image",
    icon: <IoIosImages className=" sidebar-icon " />,
  },
  {
    id: 3,
    path: "/admin/faq",
    title: "FAQ",
    icon: <FcFaq className=" sidebar-icon " />,
  },
  {
    id: 9,
    path: "/admin/brocedure",
    title: "Brochure",
    icon: <PiBrowsersDuotone className=" sidebar-icon " />,
  },
  {
    id: 10,
    path: "/admin/enquireform",
    title: "Enquire Form",
    icon: <MdConnectWithoutContact className=" sidebar-icon " />,
  },
  {
    id: 8,
    path: "/admin/carrer",
    title: "Careers",
    icon: <FaUserGraduate className="sidebar-icon " />,
  },
  {
    id: 11,
    path: "/admin/applicationForm",
    title: "Applicant Pool",
    icon: <FcGraduationCap className=" sidebar-icon " />,
  },
  {
    id: 4,
    path: "/admin/socialmedia",
    title: "Social Media",
    icon: <IoMdAppstore className=" sidebar-icon " />,
  },
  {
    id: 5,
    path: "/admin/casestudy",
    title: "Case Study",
    icon: <FcBriefcase className=" sidebar-icon " />,
  },
  {
    id: 6,
    path: "/admin/facilities",
    title: "Facilities",
    icon: <GiAstrolabe className=" sidebar-icon " />,
  },
  {
    id: 7,
    path: "/admin/expertise",
    title: "Expertise",
    icon: <AiOutlineExperiment className="sidebar-icon " />,
  },

  {
    id: 9,
    path: "/admin/contact",
    title: "Contact Us",
    icon: <FcContacts className=" sidebar-icon " />,
  },
  {
    id: 13,
    path: "/admin/teams",
    title: "Teams",
    icon: <RiTeamFill className=" sidebar-icon " />,
  },
  {
    id: 14,
    path: "/admin/certification",
    title: "Certification",
    icon: <BiSolidCertification className=" sidebar-icon " />,
  },
  {
    id: 15,
    path: "/admin/imagegallery",
    title: "Image Gallery",
    icon: <GrGallery className=" sidebar-icon " />,
  },
];
